if (typeof document === "undefined") return;
var createStylesheet = (chunkId, fullhref, oldTag, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && event.type;
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + errorType + ": " + realHref + ")");
			err.name = "ChunkLoadError";
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;


	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"portaro": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"searchHistoryPage":1,"searchFormPage":1,"loan-categories":1,"exemplar-statuses":1,"acquisition":1,"changelog":1,"favourites":1,"record-collections":1,"record-collection-content":1,"fonds.departments.divisions":1,"fonds":1,"inventories-page":1,"captures-page":1,"matches-page":1,"inventory-page":1,"thesaurus":1,"userList":1,"userAccount.recordDetail.record-grid.reportsProcessing.projects.employees.divisions":1,"userAccount.recordDetail.discount-approving.mediaViewer.reportsProcessing.reportsApproving":1,"userAccount.recordDetail.discount-approving.mediaViewer":1,"userAccount.recordDetail":1,"userAccount":1,"recordDetail":1,"sdiRequests":1,"settings":1,"utilPage":1,"activeSessionsPage":1,"reportServer":1,"messages":1,"localizations":1,"departments":1,"filters":1,"locations":1,"facet-types":1,"tenders-list":1,"tender":1,"record-exports":1,"publicStats":1,"overallStats":1,"zStats":1,"verbisbox-station-list.verbisbox-station":1,"discount-approving":1,"seekedSeekings":1,"providedSeekings":1,"loans-page":1,"attributions":1,"src_features_media-viewer_media-viewer_styles_less":1,"record-grid":1,"historicalPlaces":1,"exemplarPlacements":1,"reports":1,"reportsProcessing":1,"reportsApproving":1,"projects":1,"employees":1,"divisions":1,"threads":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr

// no prefetching

// no preloaded